import React, { useState } from "react";
import carpaccio from "./../pics/o_carpaccio.jpg";
import tartar from "./../pics/o_tartar.jpg";
import pasta from "./../pics/o_pasta.jpg";
import pulpo from "./../pics/o_pulpo.jpg";
import sushi from "./../pics/sushi.jpg";
import sushic from "./../pics/sushic2.jpg";
import mariscos from "./../pics/mariscos.jpeg";
// import rice from "./../pics/3043.jpg";
import desert from "./../pics/desert.jpg";
import desert2 from "./../pics/desert2.jpg";
import breakfast from "./../pics/desayuno.jpg";
import styles from "./styles.module.css";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";

export const Photos = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="homerediv">
      <Carousel fade activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img className={styles.gallery} src={mariscos} alt="" />
        </Carousel.Item>
        {/*   <Carousel.Item>
          <img className={styles.gallery} src={rice} alt="" />
        </Carousel.Item> */}
        <Carousel.Item>
          <img className={styles.gallery} src={sushic} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={tartar} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={carpaccio} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={pasta} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={desert} alt="" />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export const PhotosMobile = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="homerediv">
      <Carousel fade activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img className={styles.gallery} src={pulpo} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={tartar} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={sushi} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={breakfast} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={mariscos} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={pasta} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={desert2} alt="" />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};
